export const ROUTES = {
  index: () => `${ROUTES.procurement()}` as const,
  procurement: () => '/procurement-new' as const,
  projects: () => `${ROUTES.index()}/projects` as const,
  tender: (tenderId: string = ':tenderId') => `${ROUTES.tenders()}/${tenderId}` as const,
  tenderNew: () => `${ROUTES.tenders()}/new` as const,
  tenders: () => `${ROUTES.index()}/tenders` as const,
};
